import {
  GET_SURVEY_EVENT_RESPONSES,
  FETCH_SURVEY_EVENT_RESPONSE,
  ADD_SURVEY_EVENT_RESPONSE,
  UPDATE_SURVEY_EVENT_RESPONSE,
  DELETE_SURVEY_EVENT_RESPONSE,
  CLEAR_SURVEY_EVENT_RESPONSES,
  SURVEY_EVENT_RESPONSES_PAGE,
  CLEAR_ALL,
  SURVEY_EVENT_RESPONSES_PENDING, // Added pending action type
} from "../constants/actions";

const initialState = {
  survey_event_responses: [],
  pending: false,
  pageNumber: 1,
  created: false,
  updated: false,
};

export default function surveyEventResponses(state = initialState, action) {
  switch (action.type) {
    case SURVEY_EVENT_RESPONSES_PENDING: // Added pending case
      return {
        ...state,
        pending: true,
      };
    case GET_SURVEY_EVENT_RESPONSES:
      return {
        ...state,
        survey_event_responses: action.payload,
        pending: false,
      };
    case SURVEY_EVENT_RESPONSES_PAGE:
      return {
        ...state,
        pageNumber: action.payload,
      };
    case FETCH_SURVEY_EVENT_RESPONSE:
      return {
        ...state,
        [action.payload.id]: action.payload,
        pending: false,
      };
    case ADD_SURVEY_EVENT_RESPONSE:
      return {
        ...state,
        created: action.payload,
        pending: false,
      };
    case UPDATE_SURVEY_EVENT_RESPONSE:
      return {
        ...state,
        [action.payload.id]: action.payload,
        pending: false,
      };
    case DELETE_SURVEY_EVENT_RESPONSE:
      return {
        ...state,
        updated: Math.random(),
        pending: false,
      };
    case CLEAR_SURVEY_EVENT_RESPONSES:
      return {
        ...state,
        ...initialState,
      };
    case CLEAR_ALL:
      return initialState;
    default:
      return state;
  }
}